exports._prepareFormData = function (file) {
  return function () {
    var formData = new FormData();
    formData.append("file", file);
    return formData;
  };
};
